PES = PES || {}
PES.HorizontalCarousel= function() {
    var _onHoverCaptionColor = "#52b161";
    var _activeSlideCaptionColor = "rgb(214, 77, 58, 1)";
    var _slideCaptionVisibilityTimeout = 5000;
    var _hideCaption = function (target) {
        $(target).animate({
            backgroundColor: _onHoverCaptionColor,
            opacity: 0
        }, {
                duration: 500
            });
    };

    var _bindCarouselSlideCustomEvents = function (carouselSelector) {
        $(carouselSelector + " .image-with-caption").on("mouseenter", function () {
            var captionItem = $(this).find("span.caption");
            if ($(this).hasClass("active-focus") === true) return;

            $(captionItem).animate({
                opacity: 1,
                backgroundColor: _onHoverCaptionColor
            }, {
                    duration: 500
                });
        }).on("mouseleave", function () {
            var captionItem = $(this).find("span.caption");
            if ($(this).hasClass("active-focus") === true) return;

            _hideCaption(captionItem);
        });
    };

    var _activateSlide = function (slide, isFirstLoad) {
        isFirstLoad = isFirstLoad || false;
        if ($(".active-focus").length > 0) return;
        var spanCaption = $(slide).find("span.caption");

        $(slide).addClass("active-focus");
        $(spanCaption).animate({
            backgroundColor: _activeSlideCaptionColor,
            opacity: 1
        }, {
                duration: 200
            });

        if (!isFirstLoad) {
            setTimeout(function () {
                $(spanCaption).animate({
                    opacity: 0
                }, {
                        duration: 500
                    });
            }, _slideCaptionVisibilityTimeout);
        }
    };

    var _getCarouselSlide = function (carouselSelector, slideIndex) {
        return $(carouselSelector).find('.image-with-caption[data-slick-index="' + slideIndex + '"]');
    };


    var _initFirstCarousel = function () {
        $('.first-carousel').on('init', function (event, slick) {
            var slide = _getCarouselSlide('.first-carousel', slick.currentSlide);
            _activateSlide(slide, true);
        });

        $('.first-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.first-carousel').find('.slick-cloned.active-focus').removeClass('active-focus');

            var secondCarouselActiveSlide = $('.second-carousel').find(".image-with-caption.active-focus");
            if (secondCarouselActiveSlide != null && secondCarouselActiveSlide.length > 0) {
                _hideCaption($(secondCarouselActiveSlide[0]).find("span.caption"));
                $(secondCarouselActiveSlide[0]).removeClass("active-focus");
            }
            if (currentSlide === nextSlide) return;

            var slide = _getCarouselSlide('.first-carousel', currentSlide);
            var activeCaption = $(slide).find("span.caption");

            $(slide).removeClass("active-focus");
            _hideCaption(activeCaption);
        });

        $('.first-carousel').on("afterChange", function (evt, slick, currentSlide) {
            var slide = _getCarouselSlide('.first-carousel', currentSlide);
            _activateSlide(slide);
        });

        _bindCarouselSlideCustomEvents(".first-carousel");

        $('.first-carousel').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: '5%',
            responsive: [
                {
                    breakpoint: 1680,
                    settings: {
                        centerPadding: '3%'
                    }
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: '5%'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: '5%'
                    }
                }]
        });
    };

    var _initSecondCarousel = function () {
        $('.second-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var firstCarouselActiveSlide = $('.first-carousel').find(".image-with-caption.active-focus");
            if (firstCarouselActiveSlide != null && firstCarouselActiveSlide.length > 0) {
                _hideCaption($(firstCarouselActiveSlide[0]).find("span.caption"));
                $(firstCarouselActiveSlide[0]).removeClass("active-focus");
            }

            if (currentSlide === nextSlide) return;

            var slide = _getCarouselSlide('.second-carousel', currentSlide);
            var activeCaption = $(slide).find("span.caption");

            $(slide).removeClass("active-focus");
            _hideCaption(activeCaption);
        });

        $('.second-carousel').on("afterChange", function (evt, slick, currentSlide) {
            var slide = _getCarouselSlide('.second-carousel', currentSlide);
            _activateSlide(slide);
        });

        _bindCarouselSlideCustomEvents(".second-carousel");

        $('.second-carousel').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: '20%',
            responsive: [
                {
                    breakpoint: 1680,
                    settings: {
                        centerPadding: '18.7%'
                    }
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '27.5%'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '30%'
                    }
                }]
        });
    };
    var initCarousel = function () {
        //fix IE9 background-color animation
        //_onHoverCaptionColor = jQuery.Color("#52b161");
        //_activeSlideCaptionColor = jQuery.Color("rgb(214, 77, 58, 1)");

        _initFirstCarousel();
        _initSecondCarousel();
    };

    return {
        initCarousel:initCarousel
    }
}